// extracted by mini-css-extract-plugin
module.exports = {"prose":"Prose_prose__KQrSX","compact":"Prose_compact__9Bd5P"};